/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Steps_Col_ArtifactInputs */

const en_dr_steps_col_artifact = /** @type {(inputs: Dr_Steps_Col_ArtifactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artifact`)
};

const id_dr_steps_col_artifact = /** @type {(inputs: Dr_Steps_Col_ArtifactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artefak`)
};

/**
* | output |
* | --- |
* | "Artifact" |
*
* @param {Dr_Steps_Col_ArtifactInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_steps_col_artifact = /** @type {((inputs?: Dr_Steps_Col_ArtifactInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Steps_Col_ArtifactInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_steps_col_artifact(inputs)
	return en_dr_steps_col_artifact(inputs)
});